import {
    SELECT_MEDIA,                 DESELECT_MEDIA,
    SELECT_ALL_MEDIA,             DESELECT_ALL_MEDIA,
    REQUEST_MEDIA,                RECIEVE_MEDIA,
    REQUEST_DELETE_MEDIA,         RECIEVE_DELETE_MEDIA,
                                  RECIEVE_ADD_MEDIA,
    REQUEST_SCENE_REPROCESSING,   RECIEVE_SCENE_REPROCESSING,
    REQUEST_DATASET_REPROCESSING, RECIEVE_DATASET_REPROCESSING,
    REQUEST_MEDIA_REPROCESSING,   RECIEVE_MEDIA_REPROCESSING,
    REQUEST_UPDATE_MEDIA,         RECIEVE_UPDATE_MEDIA
} from '../constants/actionTypes';
import { sceneMedia } from './sceneMedia';

const mediaByScene = (state = { }, action) => {
    switch(action.type) {
        // This pattern is implementing a sub-reducer so we dont have to dig up state[action.scene] ALL. THE. TIME.
        case REQUEST_MEDIA:
        case RECIEVE_MEDIA:
        case SELECT_MEDIA:
        case DESELECT_MEDIA:
        case SELECT_ALL_MEDIA:
        case DESELECT_ALL_MEDIA:
        case REQUEST_DELETE_MEDIA:
        case RECIEVE_DELETE_MEDIA:
        case REQUEST_SCENE_REPROCESSING:
        case RECIEVE_SCENE_REPROCESSING:
        case REQUEST_DATASET_REPROCESSING:
        case RECIEVE_DATASET_REPROCESSING:
        case REQUEST_MEDIA_REPROCESSING:
        case RECIEVE_MEDIA_REPROCESSING:
        case REQUEST_UPDATE_MEDIA:
        case RECIEVE_UPDATE_MEDIA:
        case RECIEVE_ADD_MEDIA:
            return {
                ...state,
                [action.scene]: sceneMedia(state[action.scene], action)
            };

        default:
            return state;
    }
};

export default mediaByScene;



// WEBPACK FOOTER //
// ./src/reducers/mediaByScene.js